import { EventImageConsentEnum } from '@clickersphere/core/enums/EventImageConsentEnum';

export const eventImageConsentOptionKeys = {
  [EventImageConsentEnum.NOT_ASKED]: 'event.imageConsent.option.NOT_ASKED',
  [EventImageConsentEnum.GRANTED]: 'event.imageConsent.option.GRANTED',
  [EventImageConsentEnum.DENIED]: 'event.imageConsent.option.DENIED',
} as const satisfies Record<EventImageConsentEnum, string>;

export const eventImageConsentBadgeKeys = {
  [EventImageConsentEnum.NOT_ASKED]: 'event.imageConsent.badge.NOT_ASKED',
  [EventImageConsentEnum.GRANTED]: 'event.imageConsent.badge.GRANTED',
  [EventImageConsentEnum.DENIED]: 'event.imageConsent.badge.DENIED',
} as const satisfies Record<EventImageConsentEnum, string>;
